import styled from 'styled-components';
var NavSubOption = styled.a.withConfig({
  displayName: "NavSubOptionLink__NavSubOption",
  componentId: "sc-bc7fvh-0"
})(["display:block;position:relative;opacity:", ";padding:0 21px;color:", ";&:after{position:absolute;top:0;bottom:0;left:0;opacity:0;width:4px;content:'';background-color:", ";}&:hover{opacity:1;color:", ";&:after{opacity:1;}}"], function (_ref) {
  var selected = _ref.selected;
  return selected ? 1 : 0.75;
}, function (_ref2) {
  var theme = _ref2.theme,
    selected = _ref2.selected;
  return selected ? theme.mainColor : theme.colors.font;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.secondaryColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.font;
});
export var NavSubOptionLink = NavSubOption;